"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faChevronDown_1 = require("@fortawesome/pro-regular-svg-icons/faChevronDown");
const NavigationLinkMenu_1 = __importDefault(require("../NavigationLinkMenu"));
const styles = require('./NavigationLink.module.scss');
class NavigationLink extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isLinkSelected: false,
            isMenuSelected: false,
        };
        this.handleNavigationLinkMouseOver = () => {
            this.setState({ isLinkSelected: true });
        };
        this.handleNavigationLinkMouseLeave = () => {
            setTimeout(() => {
                this.setState({ isLinkSelected: false });
            }, 10);
        };
        this.handleNavigationMenuMouseOver = () => {
            this.setState({ isMenuSelected: true });
        };
        this.handleNavigationMenuMouseLeave = () => {
            setTimeout(() => {
                this.setState({ isMenuSelected: false });
            }, 10);
        };
    }
    render() {
        const _a = this.props, { href, children, rel, type, node } = _a, rest = __rest(_a, ["href", "children", "rel", "type", "node"]);
        const { isLinkSelected, isMenuSelected } = this.state;
        const sections = (node && node.sections) || [];
        const isSelected = isLinkSelected || isMenuSelected;
        return (react_1.default.createElement("li", { className: styles.li },
            react_1.default.createElement("a", Object.assign({ "aria-expanded": isSelected, className: (0, classnames_1.default)(styles.navigationLink, {
                    [styles.isSelected]: isSelected,
                }), href: href, rel: rel, onMouseOver: this.handleNavigationLinkMouseOver, onMouseLeave: this.handleNavigationLinkMouseLeave, onFocus: this.handleNavigationLinkMouseOver, onBlur: this.handleNavigationLinkMouseLeave }, rest),
                children,
                react_1.default.createElement("span", { className: styles.divider }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: styles.chevron, icon: faChevronDown_1.faChevronDown })),
            sections.length > 0 && (react_1.default.createElement(NavigationLinkMenu_1.default, { onBlur: this.handleNavigationMenuMouseLeave, onFocus: this.handleNavigationMenuMouseOver, onMouseLeave: this.handleNavigationMenuMouseLeave, onMouseOver: this.handleNavigationMenuMouseOver, sections: sections, type: type, isSelected: isSelected }))));
    }
}
exports.default = NavigationLink;
//# sourceMappingURL=NavigationLink.js.map